import { Image } from '@/components/Image';

interface CheckboxProps {
  checked: boolean;
  label?: string;
  onClick?: () => void;
}

const Checkbox = ({ checked, label, onClick }: CheckboxProps) => (
  <div className="flex flex-row gap-2 items-center cursor-pointer" onClick={onClick}>
    <Image
      src={checked ? '/icons/checkbox_on.svg' : '/icons/checkbox_off.svg'}
      alt="checkbox icon"
      className="w-6 h-6"
      width={24}
      height={24}
    />
    {label && <span className="text-[16px] leading-6 font-semibold">{label}</span>}
  </div>
);

export default Checkbox;
